import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import {FormModel} from "../../../utils/form-model";
import {NoteFormComponentModel} from "./note-form/note-form.component";
import {Subject} from "rxjs";
import {NoteDialogParameter} from "./note-dialog.component";
import {Note} from "../../../models/note.model";

@Component({
  selector: "sbb-note-edit-element",
  templateUrl: "./note-edit-element.component.html",
  styleUrls: ["./note-edit-element.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NoteEditElementComponent implements OnInit, OnDestroy {
  @Input()
  noteDialogParameter: NoteDialogParameter;

  @Output()
  noteDeleted = new EventEmitter<void>();

  formModel: FormModel<NoteFormComponentModel>;
  private destroyed = new Subject<void>();
  private deleteNoteCallback: ((noteId: number) => void) | null = null;

  ngOnInit(): void {
    this.formModel = new FormModel<NoteFormComponentModel>(
      this.noteDialogParameter.noteFormComponentModel ?? {
        id: 0,
        noteTitle: "",
        noteText: "",
        noteHeight: Note.DEFAULT_NOTE_HEIGHT,
        noteWidth: Note.DEFAULT_NOTE_WIDTH,
        notePositionX: 0,
        notePositionY: 0,
        saveNoteCallback: null,
        deleteNoteCallback: null,
        updateNoteCallback: null,
      },
    );

    this.deleteNoteCallback = this.noteDialogParameter.noteFormComponentModel.deleteNoteCallback;
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  onDeleteNote(): void {
    this.deleteNoteCallback(this.noteDialogParameter.noteFormComponentModel.id);
    this.noteDeleted.emit();
  }
}
